import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import './index.sass';

import Modal from '../../Atoms/Modal';
import Text from '../../Atoms/Text';
import ProductImageGallery from '../../Molecules/ProductImageGallery';
import ProductQuantityControls from '../../Molecules/ProductQuantityControls';
import { Product } from '../../../shared';

class OtherProductModal extends React.Component {
	render() {
		const {
			className,
			isOpened,
			onClose,
			product,
			images,
			activeImageIndex,
			onChangeImageIndex,
			quantity,
			isLoading,
			onAdd,
			onRemove,
			intl,
		} = this.props;
		const { formatMessage } = intl;
		const messages = defineMessages({
			inCartCount: {
				id: 'gallery.otherProducts.inCartCount',
				defaultMessage: '{quantity}x no carrinho',
			},
		});

		if (!product) return null;

		const description = product.description || '';
		const instructions = product.instructions || '';
		const hasDetails = description || instructions;

		return (
			<Modal
				className={`OtherProductModal ${className}`}
				isOpened={isOpened}
				onClose={onClose}
			>
				<div className="OtherProductModal__gallery">
					<ProductImageGallery
						images={images}
						activeIndex={activeImageIndex}
						onChangeIndex={onChangeImageIndex}
						imageType="large"
					/>
				</div>
				<div className="OtherProductModal__content">
					<Text className="OtherProductModal__title" variant="h6">
						{product.name}
					</Text>
					<Text className="OtherProductModal__price" variant="subtitle1">
						{Product.formatPrice(product.price)}
					</Text>
					{quantity > 0 && (
						<Text className="OtherProductModal__quantity" variant="body2">
							{formatMessage(messages.inCartCount, { quantity })}
						</Text>
					)}
					{hasDetails && (
						<div className="OtherProductModal__details">
							{description && (
								<Text className="OtherProductModal__description" variant="body2">
									{description}
								</Text>
							)}
							{instructions && (
								<Text className="OtherProductModal__instructions" variant="body2">
									{instructions}
								</Text>
							)}
						</div>
					)}
					<div
						className="OtherProductModal__action"
						onClick={(event) => event.stopPropagation()}
					>
						<ProductQuantityControls
							size="medium"
							quantity={quantity}
							isLoading={isLoading}
							onAdd={onAdd}
							onRemove={onRemove}
						/>
					</div>
				</div>
			</Modal>
		);
	}
}

OtherProductModal.propTypes = {
	className: PropTypes.string,
	isOpened: PropTypes.bool,
	onClose: PropTypes.func,
	product: PropTypes.object,
	images: PropTypes.arrayOf(PropTypes.object),
	activeImageIndex: PropTypes.number,
	onChangeImageIndex: PropTypes.func,
	quantity: PropTypes.number,
	isLoading: PropTypes.bool,
	onAdd: PropTypes.func.isRequired,
	onRemove: PropTypes.func.isRequired,
	intl: PropTypes.object.isRequired,
};

OtherProductModal.defaultProps = {
	className: '',
	isOpened: false,
	onClose: () => {},
	product: null,
	images: [],
	activeImageIndex: 0,
	onChangeImageIndex: () => {},
	quantity: 0,
	isLoading: false,
};

export default injectIntl(OtherProductModal);
